"use strict";
/*
 * Uniter Markdown Plugin - Adds support for an inline Markdown syntax to PHP
 * Copyright (c) Dan Phillimore (asmblah)
 * https://github.com/uniter/markdown-plugin/
 *
 * Released under the MIT license
 * https://github.com/uniter/markdown-plugin/raw/master/MIT-LICENSE.txt
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.factory = void 0;
var ExpressionNode = /** @class */ (function () {
    function ExpressionNode(expression) {
        this.expression = expression;
    }
    ExpressionNode.prototype.toHtml = function () {
        if (this.expression === null) {
            // Use this placeholder for obviousness rather than an empty string as per PHP
            return '[NULL]';
        }
        if (typeof this.expression !== 'string' &&
            typeof this.expression !== 'number') {
            throw new Error("Expression is of unknown type: " + typeof this.expression);
        }
        return String(this.expression);
    };
    return ExpressionNode;
}());
exports.default = ExpressionNode;
var factory = function () {
    return ExpressionNode;
};
exports.factory = factory;
//# sourceMappingURL=ExpressionNode.js.map